import { render, staticRenderFns } from "./AutocompleteDataMunicipios.vue?vue&type=template&id=63df01b4"
import script from "./AutocompleteDataMunicipios.vue?vue&type=script&lang=js"
export * from "./AutocompleteDataMunicipios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports